export const getters = {
  isAnyFormulaEditorProcessing (state) {
    return state.formulaEditorsProcessing > 0
  }
}
